import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ContentChildren, ElementRef,
  EventEmitter, HostListener,
  Input,
  OnInit,
  Output,
  QueryList, TemplateRef,
  ViewChild
} from '@angular/core';
import {FieldDefine, FieldType, FormStatus, MessageService, ServiceCode} from '../../../core';
import {Util} from '../../../core';
import {ApiService, LanguagesService} from '../../../core';
import {UserButtonDirective} from '../../directive';
import {BaseFormComponent} from '../base-form';
import {FormFieldLabelPosition} from '../../define';
import {MultiSelectComponent} from '../multi-select/multi-select.component';


@Component({
  selector: 'gc-single-form',
  templateUrl: './single-form.component.html',
  styleUrls: ['./single-form.component.less']
})
export class SingleFormComponent extends BaseFormComponent implements OnInit, AfterViewInit {
  @Input()
  width = '100%';

  @Input()
  labelPosition: FormFieldLabelPosition = 'vertical';

  @Input()
  panelStyle = null;

  @Input()
  editMode = false;

  colDiv = 4;
  @Input()
  get cols(): number{
    if (this.colDiv === 0) {
      return 0;
    }
    return 12 / this.colDiv;
  }
  set cols(v) {
    if (v > 0) {
      this.colDiv = 12 / v;
    }else {
      this.colDiv = 12;
    }
  }

  dataLoading = false;
  multiSelectComponent: MultiSelectComponent = null;

  FormStatusEnum = FormStatus;
  values: {[key: string ]: any } = {};
  fields: {[key: string ]: any } = {};
  public haveData = false;
  constructor(protected api: ApiService, protected message: MessageService,
              public lang: LanguagesService, private cd: ChangeDetectorRef, protected elm: ElementRef) {
    super(api, message, lang, elm);
    this.bottomDistance = 44;
    // this.panelStyle = elm.nativeElement.getAttribute('panelStyle');
  }

  @ViewChild('buttons') public buttons: TemplateRef<any>;
  @ContentChildren(UserButtonDirective) userButtonDirectives: QueryList<UserButtonDirective>;
  @Output()
  changed: EventEmitter<{name: string, value: any, listItem: any}> = new EventEmitter();

  ngOnInit(): void {
    if (this.height) {
      this.formHeight = this.height;
    }else{
      if (!this.bottomDistance) {
        this.formHeight = null;
      }
    }
 }

  onFieldValueChange(value, name): void {
    this.changed.emit({name, value: value.value, listItem: value.listItem});
  }

  fieldEditable(field: FieldDefine): boolean {
    return  ((field.update && (this.status === FormStatus.Edit)) ||
      (field.insert && (this.status === FormStatus.Copy || this.status === FormStatus.Insert)));
  }

  protected init(): void {
    this.loadDefine();
  }

  public loadDefine(): void {
    if (!this.apiUrl) {
      return;
    }
    this.dataLoading = true;
    this.api.define(this.apiUrl, ((code, message, define) => {
      this.dataLoading = false;
      if (code === 200) {
        // Should reset data
        this.data = [];
        const optionsMap = this.define ? this.define.optionsMap : null;
        if (optionsMap) {
          define.optionsMap = optionsMap;
        }else{
          define.optionsMap = {};
        }
        this.define = define;
        this.fields = define.fieldByNames;
        this.define.fields.forEach(
          (field) => {
            if ((field.type === FieldType.Date || field.type === FieldType.DateTime) && field.defaultValue) {
              field.defaultValue = Util.toDatetime(field.defaultValue);
            }
          }
        );

        // Field group
        this.loadFieldGroups();

        this.defineLoaded();
        this.defined.emit();
        // Change detect
        this.cd.detectChanges();

        // Load data
        this.load();
        setTimeout(() => {
          this.resize();
        }, 100);
      }
    }));
  }

  public load(): void {
    super.load(() => {
      this.status = FormStatus.View;
      if (this.data.length > 0) {
        this.haveData = true;
        this.values = this.data[0];
      } else {
        this.haveData = false;
        this.values = null;
        this.data = [];
      }
      this.updateEditCache();

      if (this.editMode) {
        if (this.data.length === 0 && this.define.optionInsert) {
          this.startInsert();
        } else if (this.data.length > 0 && this.define.optionUpdate) {
          this.startEdit();
        }
      }
      this.dataLoaded();
      this.loaded.emit();

      // Edit if have no data
      if (!this.haveData && this.define.optionInsert) {
        this.startInsert();
      }
    });
  }

  startEdit(): void {
    // Have no data
    if (!this.haveData) {
      return;
    }
    this.clearEditCache();
    this.editCache[1].edit = true;
    this.status = FormStatus.Edit;
    this.clearFileInput(1);
  }

  startCopy(): void {
    // Have no data
    if (!this.haveData) {
      return;
    }

    this.clearEditCache();
    this.data[0].new = true;
    this.values = this.data[0];
    this.status = FormStatus.Copy;
  }

  startInsert(): void {
    this.clearEditCache();

    // TODO: Check this
    let options = {};
    if (this.data.length > 0 && this.data[0]._options_) {
      options = this.data[0]._options_;
    }
    const item = {new: true, serial: 1, _options_: options};
    this.initDefaultValue(item);

    // Edit cache used for save data, don't mind for update or insert.
    if ( !this.haveData) {
      // If have not/must add new.
      this.editCache[1] = {
        edit: true,
        delete: false,
        data: {...item}
      };
      this.data.push(item);
    } else {
      this.data[0] = item;
    }
    this.values = this.data[0];
    this.status = FormStatus.Insert;
  }

  cancel(): void {
    this.clearValidate();
    Util.objectAssign(this.data[0], this.editCache[1].data);
    this.editCache[1].edit = false;
    delete this.data[0].new;

    if (!this.haveData) {
      // Cancel
      delete this.editCache[1];
      this.data = [];
      this.values = null;
    }else{
      this.values = this.data[0];
    }
    this.status = FormStatus.View;
  }

  save(): void {
    super.save(1, (success, _) => {
      if (success === ServiceCode.Success) {
        delete this.data[0].new;
        this.haveData = true;
        this.updateEditCache();
        this.status = FormStatus.View;
      }
    });
  }

  deleteConfirm(): void {
    this.message.confirm(this.lang.define.lib.deleteConfirmMessage, (r) => {
      if (r) {
        this.delete();
      }
    });
  }
  delete(): void {
    super.delete(1, (success, _) => {
      if (success === ServiceCode.Success) {
        this.load();
      }
    });
  }

  edit(): void {
    this.startEdit();
  }

  ngAfterViewInit(): void {
    this.cd.detectChanges();
    this.loadUserFields();
  }

  @HostListener('window:resize', ['$event'])
  onResize(_): void {
    this.resize();
  }

}
